export default __webpack_public_path__ + "static/1109-160e02a24204889ff07f01ecda240988.gif";